var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState, } from 'react';
import { validateExpression } from './ExpActions';
import Typeahead from '@shared/expression/Typeahead';
import Fuse from 'fuse.js';
import RelativePortal from 'react-relative-portal';
import { MdCheck, MdClose, AiOutlineFunction } from 'react-icons/all';
import { Editor, EditorState, ContentState, getDefaultKeyBinding, SelectionState } from 'draft-js';
import { List } from 'immutable';
import 'draft-js/dist/Draft.css';
import { checkExpression } from './parser';
import { ExpressionType } from '@common/api';
import { ExpressionButtonCancel, ExpressionButtonSave, ExpressionContainer, ExpressionEditorIcon, SaveStatus, } from '@styled/Expression';
import { getTagDisplayName, getTagExpression, getTagLongName } from '@data/tag/tagUtil';
import { ExpressionBlockTypes } from '@util/enums';
import { useLanguage } from '@base/LanguageProvider';
import { useTagContext } from '@data/tag/tagContext';
import { FlexRow } from '@styled/FlexWrappers';
import { useSheetRowsById } from '../../data/sheetRow/sheetRowHooks';
function filterItems(fuse, filter) {
    return fuse.search(filter).slice(0, 50);
}
function initFuse(searchables) {
    return new Fuse(searchables, {
        keys: [{ name: 'expression', weight: 0.3 }, 'longname', 'blockType', 'title'],
    });
}
export function getExpErrorString(error, L) {
    var errorString = '';
    if (error) {
        errorString = error.message ? L(error.message) : L('Formula error');
        if (error.token && error.token !== '') {
            errorString += " \"".concat(error.token, "\"");
        }
        if (error.start !== undefined && error.start !== -1) {
            if (error.end !== undefined && error.end !== -1) {
                errorString += " (".concat(error.start, "-").concat(error.end + 1, ")");
            }
            else {
                errorString += " (".concat(error.start, ")");
            }
        }
    }
    return errorString;
}
var MyDecorator = /** @class */ (function () {
    function MyDecorator(tagData, sheetRowsById) {
        this.highlighted = {};
        this.tagData = tagData;
        this.sheetRowsById = sheetRowsById;
    }
    MyDecorator.prototype.getDecorations = function (block) {
        var blockKey = block.getKey();
        var blockText = block.getText();
        var decorations = Array(blockText.length).fill(null);
        this.highlighted[blockKey] = {};
        var tokens = checkExpression(blockText, this.tagData, this.sheetRowsById).tokens;
        tokens.forEach(function (token) {
            var err = token.error ? '-error' : '';
            for (var i = token.startOffset; i <= token.endOffset; i++) {
                decorations[i] = 'token-' + token.tokenAnnotationType + err;
            }
        });
        return List(decorations);
    };
    MyDecorator.prototype.getComponentForKey = function (key) {
        return function (props) {
            return (React.createElement("span", { style: {
                    padding: props.padding || '0px 2px',
                    color: props.color,
                    fontWeight: props.fontWeight || 'normal',
                    backgroundColor: props.backgroundColor,
                    borderRadius: props.borderRadius || 0,
                    textDecoration: props.textDecoration,
                    fontSize: props.fontSize,
                    lineHeight: props.lineHeight,
                    display: props.display,
                } }, props.children));
        };
    };
    MyDecorator.prototype.getPropsForKey = function (key) {
        var textDecoration = 'initial';
        if (key.endsWith('-error')) {
            key = key.replace('-error', '');
            textDecoration = 'underline #f00 dotted';
        }
        switch (key) {
            case 'token-reference-tag':
                return {
                    padding: '0px 2px',
                    color: '#3c85ff',
                    fontWeight: 'bold',
                    textDecoration: textDecoration,
                };
            case 'token-reference-acc-tag':
                return {
                    padding: '0px 2px',
                    color: 'rgb(82, 0, 165)',
                    fontWeight: 'bold',
                    textDecoration: textDecoration,
                };
            case 'token-number':
                return { color: '#1c5494', textDecoration: textDecoration };
            case 'token-operator':
                return { color: '#000000', textDecoration: textDecoration };
            case 'token-function':
                return { color: '#09b1bc', fontWeight: 'bold', textDecoration: textDecoration };
            case 'token-comma':
                return { color: '#000000', textDecoration: textDecoration };
            case 'token-paren':
                return { color: '#000000', textDecoration: textDecoration, fontWeight: 'bold' };
            default:
                return { color: '#000000', textDecoration: textDecoration };
        }
    };
    return MyDecorator;
}());
function getReadTypeAheadItems(typeaheadState) {
    var _a;
    return typeaheadState && ((_a = typeaheadState.items[0]) === null || _a === void 0 ? void 0 : _a.expression) === typeaheadState.filter
        ? typeaheadState.items
        : typeaheadState
            ? __spreadArray([
                {
                    blockType: ExpressionBlockTypes.LITERAL,
                    title: typeaheadState.filter,
                    expression: typeaheadState.filter,
                }
            ], __read(typeaheadState.items), false) : [];
}
export function getEditorState(expression, tagData, sheetRowsById) {
    var decorator = new MyDecorator(tagData, sheetRowsById);
    var editorState = EditorState.createWithContent(ContentState.createFromText(expression), decorator);
    return editorState;
}
function ExpEditor(props, ref) {
    var _this = this;
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var sheetRowsById = useSheetRowsById();
    var fuse = useMemo(function () {
        return initFuse(props.searchables);
    }, [props.searchables]);
    var _a = __read(useState(getEditorState(props.expression, tagData, sheetRowsById)), 2), editorState = _a[0], setEditorState = _a[1];
    var _b = __read(useState(null), 2), typeaheadState = _b[0], setTypeaheadState = _b[1];
    var _c = __read(useState(false), 2), showSaveStatus = _c[0], setShowSaveStatus = _c[1];
    var _d = __read(useState(false), 2), invalid = _d[0], setInvalid = _d[1];
    var _e = __read(useState(null), 2), error = _e[0], setError = _e[1];
    var expEditorContainerRef = useRef(null);
    var expEditorRef = useRef(null);
    var readTypeAheadItems = getReadTypeAheadItems(typeaheadState);
    useImperativeHandle(ref, function () { return ({
        exportExpression: function () {
            return editorState.getCurrentContent().getPlainText('\u0001');
        },
    }); });
    useEffect(function () {
        var expression = editorState.getCurrentContent().getPlainText('\u0001');
        if (props.expression !== expression) {
            setEditorState(getEditorState(props.expression, tagData, sheetRowsById));
            setInvalid(false);
            setError(null);
            setTypeaheadState(null);
        }
    }, [props.expression, props.accTagId, sheetRowsById]);
    var getTypeaheadState = function (editorState) {
        var _a, _b;
        var exp = editorState.getCurrentContent().getPlainText('\u0001');
        if (exp.length === 0) {
            return null;
        }
        var selectionState = editorState.getSelection();
        var start = selectionState.getStartOffset();
        var end = selectionState.getEndOffset();
        var lastChangeType = editorState.getLastChangeType();
        if (!selectionState.getHasFocus()) {
            return null;
        }
        if (lastChangeType === null && start === 0 && end === 0) {
            return null;
        }
        var tokens = checkExpression(exp, tagData, sheetRowsById).tokens;
        if (tokens.length === 0) {
            return null;
        }
        var selectedToken = null;
        var tokenIndex = -1;
        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            if (token.startOffset <= start && token.endOffset >= start - 1) {
                selectedToken = token;
                tokenIndex = i;
                break;
            }
        }
        if (selectedToken === null) {
            return null;
        }
        if (selectedToken.tokenType !== 'Identifier' &&
            selectedToken.tokenType !== 'FlowReference' &&
            selectedToken.tokenType !== 'ClusterReference' &&
            selectedToken.tokenType !== 'GreaterThan' &&
            selectedToken.tokenType !== 'NumberLiteral') {
            return null; ///???
        }
        var filter = selectedToken.image;
        var parentTag = null;
        var shouldReplace = true;
        // check if the previous tokens are 'TAG' and '>' so we can filter by parent
        if (selectedToken.tokenType === 'Identifier' &&
            tokenIndex > 1 &&
            tokens[tokenIndex - 1].tokenType === 'GreaterThan') {
            var parentTagToken = tokens[tokenIndex - 2];
            if (parentTagToken.tag) {
                parentTag = parentTagToken.tag;
            }
        }
        if (selectedToken.tokenType === 'GreaterThan') {
            var parentTagToken = tokens[tokenIndex - 1];
            if (parentTagToken.tag) {
                parentTag = parentTagToken.tag;
                shouldReplace = false;
            }
            else {
                return null; //???
            }
        }
        var items = typeaheadState ? typeaheadState.items : [];
        var oldFilter = typeaheadState ? typeaheadState.filter : '';
        if (filter !== oldFilter || items.length === 0) {
            if (parentTag) {
                var tags = tagData.tagsByParentId[(_a = parentTag.id) !== null && _a !== void 0 ? _a : 'null'];
                if (!tags) {
                    items = [];
                }
                items =
                    (_b = tags === null || tags === void 0 ? void 0 : tags.map(function (t) {
                        var _a, _b, _c, _d;
                        return ({
                            blockType: ExpressionBlockTypes.TAG,
                            id: t.id,
                            title: getTagDisplayName(t),
                            expression: getTagExpression(t),
                            longName: getTagLongName(t),
                            description: (_a = t.description) !== null && _a !== void 0 ? _a : '',
                            parentTitle: (_d = (_c = tagData.tagById[(_b = t.ParentId) !== null && _b !== void 0 ? _b : -1]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
                            type: t.type,
                        });
                    })) !== null && _b !== void 0 ? _b : [];
                items =
                    filter.length > 1
                        ? items.filter(function (i) { return i.title.toLowerCase().includes(filter.toLowerCase()); })
                        : items;
            }
            else {
                var filterResult = filterItems(fuse, filter);
                items = filterResult.map(function (it) { return it.item; });
            }
        }
        return {
            filter: filter,
            selectedIndex: (typeaheadState && typeaheadState.selectedIndex) || 0,
            tokenIndexToReplace: shouldReplace ? tokenIndex : -1,
            items: items,
            arrowDirection: (typeaheadState === null || typeaheadState === void 0 ? void 0 : typeaheadState.arrowDirection) ? typeaheadState.arrowDirection : 1,
        };
    };
    var onChange = function (editorState) {
        setEditorState(editorState);
        setTypeaheadState(getTypeaheadState(editorState));
        setInvalid(false);
    };
    var focusEditor = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (expEditorRef && expEditorRef.current) {
            expEditorRef.current.focus();
        }
    };
    var hasSpaceInCurrentPosition = function () {
        if (expEditorContainerRef && expEditorContainerRef.current) {
            var rect = expEditorContainerRef.current.getBoundingClientRect();
            var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            return rect.bottom + 350 < height;
        }
        else {
            return true;
        }
    };
    var invertTypeahead = false;
    if (typeaheadState) {
        invertTypeahead = !hasSpaceInCurrentPosition();
    }
    var keyBindingFn = function (e) {
        if (e.keyCode === 13) {
            return 'enter';
        }
        else if (e.keyCode === 38) {
            return 'up';
        }
        else if (e.keyCode === 40) {
            return 'down';
        }
        else if (e.keyCode === 27) {
            return 'escape';
        }
        return getDefaultKeyBinding(e);
    };
    var handleKeyCommand = function (command) {
        if (command === 'enter') {
            if (typeaheadState && typeaheadState.items[typeaheadState.selectedIndex]) {
                handleReturn(typeaheadState.selectedIndex);
            }
            else {
                save();
                setTypeaheadState(null);
            }
            return 'handled';
        }
        else if (command === 'up') {
            onArrow(-1);
        }
        else if (command === 'down') {
            onArrow(1);
        }
        else if (command === 'escape') {
            setTypeaheadState(null);
        }
        return 'not-handled';
    };
    var handleReturn = function (idx) {
        if (typeaheadState) {
            var filteredItems = readTypeAheadItems;
            var data = filteredItems[idx || typeaheadState.selectedIndex];
            var expression = editorState.getCurrentContent().getPlainText('\u0001');
            var tokens = checkExpression(expression, tagData, sheetRowsById).tokens;
            if (tokens.length === 0) {
                setTypeaheadState(null);
                return true;
            }
            var newExpression = expression;
            var newCursorPosition = expression.length;
            // append
            if (typeaheadState.tokenIndexToReplace === -1) {
                newExpression += data.expression;
                newCursorPosition = newExpression.length;
            }
            else {
                // replace
                var tokenToReplace = tokens[typeaheadState.tokenIndexToReplace];
                newExpression =
                    expression.substring(0, tokenToReplace.startOffset) +
                        data.expression +
                        expression.substring(tokenToReplace.endOffset + 1);
                newCursorPosition = tokenToReplace.startOffset + data.expression.length;
            }
            var newES = getEditorState(newExpression, tagData, sheetRowsById);
            var newBlockKey_1;
            var newContentState = newES.getCurrentContent();
            var blockMap = newContentState.getBlockMap();
            blockMap.forEach(function (contentBlock) {
                newBlockKey_1 = contentBlock === null || contentBlock === void 0 ? void 0 : contentBlock.getKey();
            });
            var updateSelection = new SelectionState({
                anchorKey: newBlockKey_1,
                anchorOffset: newCursorPosition,
                focusKey: newBlockKey_1,
                focusOffset: newCursorPosition,
                isBackward: false,
            });
            var hasDiff = expression !== newES.getCurrentContent().getPlainText('\u0001');
            if (hasDiff) {
                setEditorState(EditorState.forceSelection(newES, updateSelection));
                setTypeaheadState(null);
                setInvalid(false);
            }
            else {
                setEditorState(EditorState.forceSelection(newES, updateSelection));
                setTypeaheadState(null);
            }
            return true;
        }
        return false;
    };
    var onArrow = function (offset) {
        var newTypeaheadState = getTypeaheadState(editorState);
        if (!newTypeaheadState) {
            return;
        }
        var items = newTypeaheadState.items;
        var newIdx = newTypeaheadState.selectedIndex + offset;
        newTypeaheadState.selectedIndex = (newIdx >= 0 ? newIdx : items.length - 1) % items.length;
        newTypeaheadState.arrowDirection = offset;
        setTypeaheadState(newTypeaheadState);
    };
    var showSaveStatusHandler = function () {
        setShowSaveStatus(true);
        setTimeout(function () {
            setShowSaveStatus(false);
        }, 1500);
    };
    var validate = function () { return __awaiter(_this, void 0, void 0, function () {
        var exp, errors, compilationErrors, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    exp = editorState.getCurrentContent().getPlainText('\u0001');
                    if (exp === '' || exp === null) {
                        setInvalid(false);
                        setError(null);
                        return [2 /*return*/, Promise.resolve(exp)];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    errors = checkExpression(exp, tagData, sheetRowsById).errors;
                    if (errors && errors.length > 0) {
                        setInvalid(true);
                        setError(errors[0]);
                        return [2 /*return*/, false];
                    }
                    return [4 /*yield*/, validateExpression(ExpressionType.Account, exp)];
                case 2:
                    compilationErrors = _a.sent();
                    if (compilationErrors.length > 0) {
                        setInvalid(true);
                        setError(compilationErrors[0]);
                        return [2 /*return*/, false];
                    }
                    else {
                        setInvalid(false);
                        setError(null);
                        return [2 /*return*/, exp];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setInvalid(true);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var save = function () {
        if (props.done) {
            return validate().then(function (expression) {
                if (expression !== false) {
                    props.done ? props.done(expression) : null;
                    setInvalid(false);
                    showSaveStatusHandler();
                }
            });
        }
    };
    var cancel = function () {
        var editorState = getEditorState(props.expression, tagData, sheetRowsById);
        setEditorState(EditorState.moveFocusToEnd(editorState));
        setInvalid(false);
    };
    return (React.createElement(ExpressionContainer, { ref: expEditorContainerRef, className: "tiny-scrollbars", onFocus: focusEditor, style: props.style },
        !!typeaheadState && typeaheadState.items.length ? (React.createElement(RelativePortal, { component: "div", top: invertTypeahead ? 1 : 46 },
            React.createElement(Typeahead, __assign({ clickHandler: handleReturn, invert: invertTypeahead }, typeaheadState, { items: readTypeAheadItems })))) : null,
        React.createElement(ExpressionEditorIcon, null,
            React.createElement(AiOutlineFunction, null)),
        React.createElement(Editor, { ref: expEditorRef, placeholder: props.placeholder ? props.placeholder : L('Enter formula here'), editorState: editorState, onChange: onChange, keyBindingFn: keyBindingFn, handleKeyCommand: handleKeyCommand, readOnly: props.isReadOnly === true ? true : false }),
        showSaveStatus && React.createElement(SaveStatus, null, L('Saved')),
        invalid && React.createElement(SaveStatus, { className: "error" }, getExpErrorString(error, L)),
        props.showBtns && (React.createElement(FlexRow, null,
            React.createElement(ExpressionButtonSave, { onClick: save, type: "submit" },
                React.createElement(MdCheck, null)),
            React.createElement(ExpressionButtonCancel, { onClick: cancel },
                React.createElement(MdClose, null))))));
}
export default forwardRef(ExpEditor);
